var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.stockGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.stockGetErrors = $event
          }
        }
      }),
      _c("base-snackbar", {
        attrs: { errors: _vm.orderDetailPostErrors },
        on: {
          "update:errors": function($event) {
            _vm.orderDetailPostErrors = $event
          }
        }
      }),
      _c("base-snackbar", {
        attrs: { errors: _vm.orderDetailStatusGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.orderDetailStatusGetErrors = $event
          }
        }
      }),
      _c("v-data-table", {
        attrs: {
          items: _vm.dataList,
          headers: _vm.headers,
          "hide-default-footer": "",
          dense: ""
        },
        scopedSlots: _vm._u([
          {
            key: "body.append",
            fn: function() {
              return [
                _c("tr", [
                  _c("th", { attrs: { colspan: "6", align: "center" } }, [
                    _vm._v("Total")
                  ]),
                  _c("td", { attrs: { align: "right" } }, [
                    _vm._v(_vm._s(_vm.totalAmountItems.phpFormat()))
                  ])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function({ item, index }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.stockId))]),
                  _c("td", { attrs: { align: "right" } }, [
                    _vm._v(_vm._s(item.quantity))
                  ]),
                  _c("td", { attrs: { align: "right" } }, [
                    _vm._v(_vm._s(item.unitPrice))
                  ]),
                  _c("td", { attrs: { align: "right" } }, [
                    _vm._v(_vm._s(item.discount))
                  ]),
                  _c("td", [_vm._v(_vm._s(item.orderDetailStatusId))]),
                  _c("td", [_vm._v(_vm._s(item.dateAllocated.dateFormat({})))]),
                  _c("td", { attrs: { align: "right" } }, [
                    _vm._v(
                      _vm._s(
                        (
                          item.quantity *
                          (item.unitPrice - item.discount)
                        ).phpFormat()
                      )
                    )
                  ]),
                  _c(
                    "td",
                    { attrs: { align: "center" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "yellow", "x-small": "" },
                          on: {
                            click: function($event) {
                              return _vm.editData(item, index)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-pencil")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "error", "x-small": "" },
                          on: {
                            click: function($event) {
                              return _vm.removeData(index)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-delete")])],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c("tr", [
                  _c(
                    "td",
                    { attrs: { colspan: _vm.headers.length } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          attrs: {
                            color: "primary",
                            dense: "",
                            dark: "",
                            elevation: "0"
                          }
                        },
                        [_c("span", [_vm._v("New Item")])]
                      ),
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { lg: "2", cols: "12" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Date Allocated",
                                      type: "date",
                                      "error-messages":
                                        _vm.orderDetailPostErrors
                                          .date_allocated || []
                                    },
                                    model: {
                                      value: _vm.dateAllocated,
                                      callback: function($$v) {
                                        _vm.dateAllocated = $$v
                                      },
                                      expression: "dateAllocated"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { lg: "2", cols: "12" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      label: "Stock",
                                      items: _vm.computedStockId,
                                      "item-value": "id",
                                      "item-text": "id",
                                      filter: _vm.filterStockAutocomplete,
                                      "error-messages":
                                        _vm.orderDetailPostErrors.stock_id || []
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "item",
                                        fn: function({ item }) {
                                          return [
                                            _c("span", [
                                              _vm._v(_vm._s(item.id))
                                            ]),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "ml-2 grey--text text-uppercase"
                                              },
                                              [_vm._v(_vm._s(item.description))]
                                            )
                                          ]
                                        }
                                      }
                                    ]),
                                    model: {
                                      value: _vm.stockId,
                                      callback: function($$v) {
                                        _vm.stockId = $$v
                                      },
                                      expression: "stockId"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    lg: "2",
                                    "lg-offset": "2",
                                    cols: "12"
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Quantity",
                                      type: "number",
                                      "error-messages":
                                        _vm.orderDetailPostErrors.quantity || []
                                    },
                                    model: {
                                      value: _vm.quantity,
                                      callback: function($$v) {
                                        _vm.quantity = $$v
                                      },
                                      expression: "quantity"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { lg: "2", cols: "12" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: { label: "Unit", items: _vm.units },
                                    model: {
                                      value: _vm.unit,
                                      callback: function($$v) {
                                        _vm.unit = $$v
                                      },
                                      expression: "unit"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { lg: "2", cols: "12" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Unit Price",
                                      type: "number",
                                      "error-messages":
                                        _vm.orderDetailPostErrors.unit_price ||
                                        []
                                    },
                                    model: {
                                      value: _vm.unitPrice,
                                      callback: function($$v) {
                                        _vm.unitPrice = $$v
                                      },
                                      expression: "unitPrice"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    lg: "2",
                                    "lg-offset": "6",
                                    cols: "12"
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Discount",
                                      "error-messages":
                                        _vm.orderDetailPostErrors.discount || []
                                    },
                                    model: {
                                      value: _vm.discount,
                                      callback: function($$v) {
                                        _vm.discount = $$v
                                      },
                                      expression: "discount"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { lg: "4", cols: "12" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      label: "Order Status",
                                      loading: _vm.orderDetailStatusGetting,
                                      items: _vm.orderDetailStatusList,
                                      "item-value": "id",
                                      "item-text": "name",
                                      "error-messages":
                                        _vm.orderDetailPostErrors
                                          .order_detail_status_id || []
                                    },
                                    model: {
                                      value: _vm.orderDetailStatusId,
                                      callback: function($$v) {
                                        _vm.orderDetailStatusId = $$v
                                      },
                                      expression: "orderDetailStatusId"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "mb-2",
                                  attrs: { lg: "2", cols: "12" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        block: "",
                                        tile: "",
                                        color: "success",
                                        loading: _vm.orderDetailPosting
                                      },
                                      on: { click: _vm.appendData }
                                    },
                                    [_c("span", [_vm._v("ADD")])]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "50vw", eager: "" },
          model: {
            value: _vm.editItemDialog,
            callback: function($$v) {
              _vm.editItemDialog = $$v
            },
            expression: "editItemDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("edit-detail", {
                ref: "edit-detail",
                attrs: { stocks: _vm.stockList },
                on: {
                  "update-detail": _vm.updateDetail,
                  close: function($event) {
                    return _vm.openEditDialog(false)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }